import React from 'react'
import {HashRouter} from "react-router-dom";
import './App.css';
import MyRouter from "./router";


function App() {
  return (
    <div className="App">
      <HashRouter>
          <MyRouter></MyRouter>
      </HashRouter>
    </div>
  );
}

export default App;
